// NOTE: line-ban-management/src/utils/getFileTypeFromUrl.ts と同一実装。
// 修正するときは両方を同期すること。
const IMAGE_EXTENSIONS: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  apng: 'image/apng',
  avif: 'image/avif',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  webp: 'image/webp',
};

const VIDEO_EXTENSIONS: Record<string, string> = {
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  quicktime: 'video/quicktime',
};

const DOCUMENT_EXTENSIONS: Record<string, string> = {
  pdf: 'application/pdf',
  zip: 'application/zip',
};

// 拡張子は送信者が付けたファイル名由来なので、'constructor' 等のプロトタイプ由来キーで
// 文字列以外が返らないよう、自身のプロパティだけを参照する
const lookupMimeType = (
  table: Record<string, string>,
  ext: string,
): string | undefined =>
  Object.prototype.hasOwnProperty.call(table, ext) ? table[ext] : undefined;

/**
 * PubNub ファイル URL などから MIME タイプを推定する。
 * クエリ文字列（?uuid= 等の署名パラメータ）とフラグメント（#t= 等）は無視し、
 * パス末尾の拡張子で判定する。
 * 判定できない場合は image/png にフォールバックする。
 */
const getFileTypeFromUrl = (url: string): string => {
  const path = url.split(/[?#]/)[0];
  const ext = path.split('.').pop()?.toLowerCase() ?? '';
  return (
    lookupMimeType(IMAGE_EXTENSIONS, ext) ||
    lookupMimeType(VIDEO_EXTENSIONS, ext) ||
    lookupMimeType(DOCUMENT_EXTENSIONS, ext) ||
    'image/png'
  );
};

export default getFileTypeFromUrl;
